import React, { useState } from 'react';
import styles from './SuperCourseNew.module.scss';
import Header from '../../../../components/header/Header';
import CourseEditForm, { EditProgram } from '../course-edit-form/CourseEditForm';
import { gql, useMutation } from '@apollo/client';
import { useHistory } from 'react-router-dom';
import { logger } from '../../../../utils/logger';
import FooterPage from '@src/components/footer-page/FooterPage';

const createProgramMutation = gql`
    mutation CreateProgram($input: ProgramEditInput) {
        createProgram(input: $input)
    }
`;

type CreateProgramResponse = {
  createProgram: string;
};

function SuperCourseNew() {
  const history = useHistory();

  const [createProgram] = useMutation<CreateProgramResponse>(createProgramMutation, {
    onCompleted(res) {
      if (res.createProgram) {
        history.push(`/super/courses/edit/${res.createProgram}`);
      }
    },
    onError(e) {
      logger.debug(`[e]`);
      alert(e.message);
      setLoading(false);
    }
  });

  const [loading, setLoading] = useState(false);

  const saveProgram = async (p: EditProgram) => {
    try {
      setLoading(true);
      createProgram({
        variables: {
          input: {
            name: p.name,
            image: p.image,
            description: p.description,
            grade: p.grade,
            isParentCourse: p.isParentCourse,
            country: p.country
          },
        }
      });
    } catch (e) {
      logger.debug(`[e]`, e);
      alert('Something went wrong.');
    }
  };

  return (
    <>
      <Header />
      <div className={styles.page}>
        <div className={styles.list}>
          <div className={styles.programName}>New Course</div>
        </div>
        <div className={styles.content}>
          <CourseEditForm loading={loading} onSave={saveProgram} course={undefined}/>
        </div>
        <FooterPage />
      </div>
    </>
  );
}

export default SuperCourseNew;
